import React from 'react'
import styles from "../styles/HeaderSection.module.scss";
import ReactPlayer from 'react-player/lazy';
import { isMobile } from 'react-device-detect';
import { useMediaQuery } from 'react-responsive';

const HeaderSection = (props) => {
  const { backgroundImg, mobileImg } = props;


  const DesktopRender = () => {

    const isWideWidth = useMediaQuery({
      query: '(min-width: 1025px)'
    })
    return (
      <div className={styles.headerSection}>


      { isWideWidth ? 
      <div className={styles.headerSectionWrapper}>
      <div className={styles.headerSectionContent}>
        <h1>Explore.</h1>
        <h1>Share.</h1>
        <h1>Preview.</h1>
        <p>
        With Buildbox World you can explore and play exciting bits created by the Buildbox community from around the globe! Create your own bit using the Buildbox desktop application, then preview and share right on Buildbox World! Now available on iOS and Android.
        </p>           
        <div className={styles.preorderBadgeWrapper}>

            <a
              href="https://apps.apple.com/us/app/buildbox-world/id1544021219"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.appstoreBtn}
                src="https://frontend-assets.buildbox.com/AppStoreButton.png"
                alt="Download Buildbox World App Store"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.apponboard.bbworld"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.appstoreBtn}
                src="https://frontend-assets.buildbox.com/GooglePlay.png"
                alt="Buildbox World Google Play Button"
              />
            </a>

        </div>
      </div>
      <ReactPlayer  
              className={styles.headerSectionImage}
               width='100vw'
               height='auto'
               playing={true}
               loop={true}
               muted={true}
               url={backgroundImg} />    
    </div>
    :
      <div className= {styles.headerSectionStack}>
          <div className={styles.headerSectionContent}>
                  <h1>Explore.</h1>
                  <h1>Share.</h1>
                  <h1>Preview.</h1>
                  <p>
                  With Buildbox World you can explore and play exciting bits created by the Buildbox community from around the globe! Create your own bit using the Buildbox desktop application, then preview and share right on Buildbox World! Now available on iOS and Android.
                  </p>           
                  <div className={styles.preorderBadgeWrapper}>

                      <a
                        href="https://apps.apple.com/us/app/buildbox-world/id1544021219"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={styles.appstoreBtn}
                          src="https://frontend-assets.buildbox.com/AppStoreButton.png"
                          alt="Download Buildbox World App Store"
                        />
                      </a>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.apponboard.bbworld"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={styles.appstoreBtn}
                          src="https://frontend-assets.buildbox.com/GooglePlay.png"
                          alt="Buildbox World Google Play Button"
                        />
                      </a>

                  </div>
              </div>
             <ReactPlayer  
              className={styles.headerSectionImage}
               width='100vw'
               height='auto'
               playing={true}
               loop={true}
               muted={true}
               url={backgroundImg} />    
      </div>
      
    }
    </div>
    )
  }


  const MobileRender = () => {
    return (
      <div className={styles.mobileContainer}> 
        <div className={styles.mobileHeader}>
        
          <h1>Explore. Share. <br/>Preview.</h1>
          <div className= {styles.mobileButtons}>
              <a
                  href="https://apps.apple.com/us/app/buildbox-world/id1544021219"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={styles.appstoreBtn}
                    src="https://frontend-assets.buildbox.com/AppStoreButton.png"
                    alt="Download Buildbox World App Store"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.apponboard.bbworld"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={styles.appstoreBtn}
                    src="https://frontend-assets.buildbox.com/GooglePlay.png"
                    alt="Buildbox World Google Play Button"
                  />
                </a>  
          </div>    
          <div className={styles.mobileText}>
            <p>
            With Buildbox World you can explore and play exciting bits created by the Buildbox community from around the globe! Create your own bit using the Buildbox desktop application, then preview and share right on Buildbox World! Now available on iOS and Android.
            </p>           
          </div>
        </div>
        <div className={styles.mobileImgContainer}>
          <img src={mobileImg} alt="header"/>
        </div>
      </div>
    )
  }
  return (
  <>
   {!isMobile && <DesktopRender/>} 
   {isMobile && <MobileRender/>} 
  </>
  )
}
export default HeaderSection
